function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.8322 1.57422H3.16555C2.00838 1.57422 1.07031 2.51229 1.07031 3.66946V18.3361C1.07031 19.4933 2.00838 20.4314 3.16555 20.4314H17.8322C18.9894 20.4314 19.9275 19.4933 19.9275 18.3361V3.66946C19.9275 2.51229 18.9894 1.57422 17.8322 1.57422Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.88571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.36086 9.9522C8.51803 9.9522 9.4561 9.01413 9.4561 7.85696C9.4561 6.69979 8.51803 5.76172 7.36086 5.76172C6.2037 5.76172 5.26562 6.69979 5.26562 7.85696C5.26562 9.01413 6.2037 9.9522 7.36086 9.9522Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.88571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.933 14.1472L16.7001 10.9142C16.3072 10.5214 15.7743 10.3008 15.2188 10.3008C14.6632 10.3008 14.1303 10.5214 13.7374 10.9142L4.21875 20.4329",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.88571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.00371ede9dd4591cb429214a2494d216.svg";
export { ForwardRef as ReactComponent };